/* global tw */
import React from 'react'
import { MDXProvider } from '@mdx-js/react'
import { Textfit } from 'react-textfit'
import 'normalize.css'
import theme from 'prism-react-renderer/themes/nightOwl'
import { Code } from './CodeBlock'

const FitH1 = ({ children, ...props }) => (
  <h1 {...props}>
    <Textfit mode="single">{children}</Textfit>
  </h1>
)

const components = {
  h1: FitH1,
  code: Code,
}
const Layout = ({ children }) => (
  <div css={tw`flex justify-center items-center bg-grey-light`}>
    <div
      css={tw`bg-white container my-8 mx-auto max-w-xl shadow-lg rounded-lg font-sans`}
    >
      <div
        css={tw`px-16 py-4 text-center text-grey-darkest text-xl sm:text-left sm:flex-grow leading-normal`}
      >
        <MDXProvider components={components}>{children}</MDXProvider>
      </div>
    </div>
  </div>
)

export default Layout
